export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OCDetailsModal.vue?vue&type=template&id=5227648d"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/InventoryLog/OCDetailsModal.vue?vue&type=template&id=5227648d
// module id = 2233
// module chunks = 31